import {Avatar, Button, Image, message, Modal} from 'antd'
import {AppLogoSvg} from 'appConfigs/svgs/AppLogoSvg'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getAvatar from 'helpers/getAvatar'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {useAppConfig} from 'modules/local/AppConfigContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useEffect, useState} from 'react'
import OrganizationContainerContext from '../OrganizationContainerContext'
import TooltipApp from "components/TooltipApp";
import {VerifiedSvg} from "../../../../components/Svgs/VerifiedSvg";
import {PhotoPlaceholderApp} from "../../../../conts/imageBase64";
import {FaEarthAsia, FaLock} from "react-icons/fa6";
import {getId, getType} from "../../../../apis/model/base";
import {IoEarth, IoExitOutline} from "react-icons/io5";
import {useJoin} from "../../../Server/ServerContainer";
import {TbBrandYoutubeFilled, TbHeartCheck, TbHeartX} from "react-icons/tb";
import {BsFacebook, BsThreeDots, BsTwitterX} from "react-icons/bs";
import LinkedPageIcon from "../../../../components/LinkedPageIcon";
import {formatNumber} from "../../../../helpers/number";
import {RiSignalTowerFill} from "react-icons/ri";
import {BiSolidChurch} from "react-icons/bi";
import {renderIf} from "../../../Shared";
import {VscArrowLeft} from "react-icons/vsc";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {SystemPermission} from "../../../../components/RequiredAdmin";
import DrawMenu from "../../../../components/drawer/DrawMenu";
import {PiLinkBold} from "react-icons/pi";
import copyToClipboard from "copy-to-clipboard";
import {createFacebookShareLink, createTwitterShareLink} from "../../../../helpers";
import {usePromoFunc} from "../../../Shared/functions/usePromoFunc";
import {ROOT_URL} from "../../../../envs/_current/config";
import getLinkToDetail from 'helpers/getLinkToDetail'
import {JoinButton} from "../../custom/ToggleActionButton";
import {FollowButton} from "../../../../components/Feed/FollowButton";


const OrganizationBanner = React.memo(({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)
    const {isSm, isLg} = useContext(LayoutContext)

    const {org_types = {}} = useAppConfig('org_types')
    const history = useHistory()

    const {
        cover_photo, photos = [], association,
        privacy, certified, description,
        total_followers, total_members, total_channels,
        parish, diocese,
        follow_status, joined_status, contacts = [],
        website, video_url, linked_pages = []
    } = organization ?? {}

    const [imageIndex, setImageIndex] = useState(0)
    const all_photos = [cover_photo, ...photos].filter((e) => !!e)
    const org_type = _.get(org_types, _.get(organization, 'org_type') || '900')
    const verified = certified

    const heightStyle = isSm ? 150 : 180
    const shareUrl = `${ROOT_URL}${getLinkToDetail(organization)}`

    const {onAddToRecommendation, onRemoveFromRecommendation} = usePromoFunc({})

    const action_params = {
        id: getId(organization),
        type: getType(organization),
    }
    useEffect(() => {
        const interval = setInterval(() => {
            const newImageIndex = (imageIndex === all_photos.length - 1) ? 0 : (imageIndex + 1)
            setImageIndex(newImageIndex)
        }, 8000)

        return () => clearInterval(interval)
    }, [imageIndex, all_photos])

    const handleLeave = useJoin({
        id: getId(organization),
        type: getType(organization),
        status: true,
    })

    const showConfirmDialog = useCallback(
        (onOk) =>
            Modal.confirm({
                title: t('do you want to leave'),
                content: (
                    <span className="text-sm text-color-400 italic">
                        {t('you will no longer be a member of this community')}
                    </span>
                ),
                className: 'custom-modal',
                okText: t('sure'),
                cancelText: t('ignore'),
                okButtonProps: {
                    type: 'primary',
                    danger: true,
                    className: 'rounded-lg no-shadow no-text-shadow no-border',
                },
                cancelButtonProps: {
                    className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
                },
                onOk,
            }),
        [t]
    )

    return  (
        <div
            className={classNames(
                "flex flex-col relative",
                isLg ? "-mx-3 mt-6 mt-6 mb-3 rounded-xl overflow-hidden" : "-mx-3 -mt-3 mb-4"
            )}>
            {/* Ảnh bìa */}
            <div style={{ height: heightStyle }} className="w-full flex justify-end relative">
                {!!all_photos.length ? (
                    <div
                        key={imageIndex}
                        style={{
                            objectFit: 'cover',
                            background: 'var(--background-100)',
                            backgroundImage: `url(${all_photos[imageIndex]})`,
                            backgroundSize: 'contain',
                            backgroundPosition: '50% 50%',
                        }}
                        className="w-full h-full flex justify-center blurInLeft animated object-cover shadow-md"
                    />
                ) : (
                    <Image
                        preview={false}
                        src={PhotoPlaceholderApp}
                        wrapperClassName="w-full h-full"
                        className="fadeIn animated object-cover"
                        style={{backgroundSize: 'contain'}}
                    />
                )}
                {/* Đếm số ảnh */}
                {all_photos.length > 1 && (
                    <div
                        style={{
                            background: 'rgba(0,0,0,0.1)',
                            borderBottomRightRadius: '0.5rem',
                            borderTopLeftRadius: '0.5rem',
                        }}
                        className="absolute p-1 bottom-0 right-0">
                        {all_photos.map((e, index) => (
                            <span
                                key={index}
                                onClick={() => {setImageIndex(index)}}
                                className={classNames(
                                    'mx-2 font-medium text-sm text-white italic cursor-pointer',
                                    imageIndex === index ? 'font-bold' : 'opacity-50 hover:opacity-100'
                                )}>
                                {index + 1}
                            </span>
                        ))}
                    </div>
                )}
                {!isLg && (
                    <div
                        onClick={() => history.goBack()}
                        style={{
                            width: 32, height: 32,
                            borderRadius: 999,
                        }}
                        className="absolute top-10 left-10 flex flex-center bg-white opacity-60 cursor-pointer">
                        <VscArrowLeft size={16} className="text-gray-700"/>
                    </div>
                )}
            </div>
            <div style={{marginTop: isLg ? -40 : -30}} className="w-full max-w-6xl mx-auto px-3 md:px-2 flex flex-col gap-3">
                <div className="flex items-end justify-between gap-3">
                    <Avatar
                        shape="square"
                        className="background-200 flex flex-center z-10"
                        style={{ boxShadow: '0px 6px 10px 2px rgba(0,0,0,0.15)', border: '4px solid #fff', borderRadius: isLg ? '1rem' : '0.5rem'}}
                        size={isLg ? 100 : 76}
                        icon={<AppLogoSvg size={isLg ? 60 : 38}/>}
                        src={getAvatar(organization)}
                        alt={getTitle(organization)}
                    />
                    <div className="flex items-center gap-x-2 md:gap-x-3 mb-2">
                        {!joined_status && (
                            <JoinButton {...action_params} item={organization} style={{height: 28, fontStyle: 'italic'}} className="rounded-full"/>
                        )}
                        {/* Chưa tham gia -> Join là primary, Follow lùi thành secondary (join đã bao hàm
                            follow) - học theo trải nghiệm Twitter/X. Đã tham gia (Join ẩn) -> Follow trở
                            lại bình thường vì lúc này là action duy nhất còn hiển thị. */}
                        <FollowButton item={organization} size="medium" secondary={!joined_status}/>
                        <SystemPermission system={true}>
                            {(isAdmin) => (
                                <DrawMenu
                                    menu={{
                                        items: [
                                            {
                                                key: 'COPY_LINK',
                                                icon: <PiLinkBold className="text-blue-600"/>,
                                                label: (
                                                    <span className="text-color-100">
                                                        {t('copy link')}
                                                    </span>
                                                ),
                                            },
                                            {
                                                key: 'SHARE_FACEBOOK',
                                                icon: <BsFacebook className="text-blue-800"/>,
                                                label: (
                                                    <span className="text-color-100">
                                                        Facebook
                                                    </span>
                                                ),
                                            },
                                            {
                                                key: 'SHARE_TWITTER',
                                                icon: <BsTwitterX className="text-color-000"/>,
                                                label: (
                                                    <span className="text-color-100">
                                                        X (Twitter)
                                                    </span>
                                                ),
                                            },
                                            ...(isAdmin ? [
                                                {
                                                    key: 'ADD_TO_RECOMMENDATION',
                                                    icon: <TbHeartCheck className="text-primary-600"/>,
                                                    label: (
                                                        <span className="text-color-100">
                                                            {t('add to recommendation')}
                                                        </span>
                                                    ),
                                                },
                                                {
                                                    key: 'REMOVE_FROM_RECOMMENDATION',
                                                    icon: <TbHeartX className="text-primary-600"/>,
                                                    label: (
                                                        <span className="text-color-100">
                                                            {t('remove from recommendation')}
                                                        </span>
                                                    ),
                                                },
                                            ] : []),
                                            ...(joined_status ? [
                                                {
                                                    key: 'LEAVE_ORG',
                                                    icon: <IoExitOutline className="text-secondary-600"/>,
                                                    label: (
                                                        <span className="text-color-100">
                                                            {t('leave')}
                                                        </span>
                                                    ),
                                                },
                                            ] : []),
                                        ],
                                        onClick: ({key}) => {
                                            switch (key) {
                                                case 'COPY_LINK':
                                                    copyToClipboard(shareUrl)
                                                    message.success(t('copied'))
                                                    break
                                                case 'SHARE_FACEBOOK':
                                                    window.open(createFacebookShareLink(shareUrl), '_blank')
                                                    break
                                                case 'SHARE_TWITTER':
                                                    window.open(createTwitterShareLink(shareUrl), '_blank')
                                                    break
                                                case 'ADD_TO_RECOMMENDATION':
                                                    onAddToRecommendation({
                                                        owner_type: getType(organization),
                                                        owner_id: getId(organization),
                                                    })
                                                    break
                                                case 'REMOVE_FROM_RECOMMENDATION':
                                                    onRemoveFromRecommendation({
                                                        owner_type: getType(organization),
                                                        owner_id: getId(organization),
                                                    })
                                                    break
                                                case 'LEAVE_ORG':
                                                    showConfirmDialog(handleLeave)
                                                    break;
                                                default:
                                                    break
                                            }
                                        },
                                    }}
                                    menuPlacement="bottomLeft"
                                    component={
                                        <Button
                                            color="default" variant="filled"
                                            style={{ width: 28, height: 28 }}
                                            className="flex flex-center text-color-300 px-1 rounded-full">
                                            <BsThreeDots size={14} />
                                        </Button>
                                    }
                                />
                            )}
                        </SystemPermission>
                    </div>
                </div>
                <div className="flex flex-col gap-3">
                    <h1 className="font-bold text-lg md:text-2xl text-color-000 max-lines-1 leading-snug">
                        {getTitle(organization)}
                        {/* association = đã liên kết/xác thực với 1 bản ghi chính thức trong hệ
                                thống - CÙNG Ý NGHĨA "đã xác thực" như verified, nên dùng chung 1 icon
                                VerifiedSvg (không phải icon link riêng) và gộp chung 1 chỗ cạnh tên,
                                không tách dòng riêng bên dưới nữa (trước đây lặp lại y hệt tên tổ
                                chức, thừa 1 dòng). verified ưu tiên hiển thị message trước nếu có cả
                                2; tên đối tượng được liên kết (association) vẫn xem được qua tooltip. */}
                        {(verified === 1 || association) && (
                            <TooltipApp
                                title={verified === 1 ? t('verified') : t('linked with name', {name: association?.fullname})}
                                placement="right"
                                color="#87d068">
                                <VerifiedSvg
                                    size={isSm ? 16 : 20}
                                    className="ml-3"
                                />
                            </TooltipApp>
                        )}
                    </h1>
                    <div className="flex flex-wrap gap-x-4 gap-y-1">
                        {(
                            <span className="flex items-center gap-1 flex-shrink-0 font-semibold text-blue-600 tracking-wider">
                                {t(org_type || 'group')}
                            </span>
                        )}
                        {organization?.public === 1 ? (
                            <span className="flex items-center gap-1 text-gray-700">
                                <FaEarthAsia size={12}/>
                                <span className="font-medium">
                                    {t('public')}
                                </span>
                            </span>
                        ) : (
                            <span className="flex items-center gap-1 text-gray-700">
                                <FaLock size={12}/>
                                <span className="font-medium">
                                    {t('private')}
                                </span>
                            </span>
                        )}
                        {renderIf(
                            diocese,
                            <span className="flex items-center gap-1 font-medium text-gray-700">
                                <BiSolidChurch size={13}/>
                                {diocese?.fullname}
                            </span>
                        )}
                    </div>
                    {description && (
                        <p className="my-0.5 text-sm text-gray-700 tracking-wide max-lines-2">
                            {description}
                        </p>
                    )}
                    <div className="flex flex-wrap gap-x-4 gap-y-1">
                        {total_followers > 0 && (
                            <span className="text-color-300 whitespace-no-wrap">
                                        <span className="mr-1 tabular-nums font-semibold text-color-000">
                                            {formatNumber(total_followers)}
                                        </span>
                                {t('followers')}
                                    </span>
                        )}
                        {total_members > 0 && (
                            <span className="text-color-300 whitespace-no-wrap">
                                        <span className="mr-1 tabular-nums font-semibold text-color-000">
                                            {formatNumber(total_members)}
                                        </span>
                                {t('members')}
                                    </span>
                        )}
                        {total_channels > 0 && (
                            <span className="flex items-center text-color-300 whitespace-no-wrap">
                                        <RiSignalTowerFill size={12} className="mr-1"/>
                                        <span className="mr-1 tabular-nums font-semibold text-color-000">
                                            {formatNumber(Number(total_channels))}
                                        </span>
                                {t('channels')}
                                    </span>
                        )}
                    </div>
                    {/* Link các trang chính thức (Facebook/Youtube/Website) - đặt ngay dưới tên
                            tổ chức kiểu Twitter/X, không cần tiêu đề riêng ("Trang chính thức của
                            Cộng đoàn" đã bỏ, trước đây nằm ở sidebar OrganizationJoinBlock). */}
                    {(linked_pages.length > 0 || video_url || website) && (
                        <div className="mb-1 flex flex-wrap items-center gap-x-4 gap-y-2">
                            {linked_pages.map((e, i) => (
                                <a
                                    key={i} href={e?.url}
                                    target="_blank" rel="noopener noreferrer"
                                    className="flex items-center gap-1.5 text-slate-600 hover:text-primary no-underline">
                                    <LinkedPageIcon url={e.url} size={14}/>
                                    <span className="font-medium text-xs tracking-wider leading-snug">
                                            {e?.page?.replace(/^https?:\/\//, '')}
                                        </span>
                                </a>
                            ))}
                            {video_url && (
                                <a
                                    href={video_url}
                                    target="_blank" rel="noopener noreferrer"
                                    className="flex items-center gap-1.5 text-slate-600 hover:text-red-600 no-underline">
                                    <TbBrandYoutubeFilled size={14} className="text-red-600"/>
                                    <span className="font-medium text-xs tracking-wider leading-snug">
                                            {'Youtube'}
                                        </span>
                                </a>
                            )}
                            {website && (
                                <a
                                    href={website}
                                    target="_blank" rel="noopener noreferrer"
                                    className="flex items-center gap-1.5 text-slate-600 hover:text-indigo-500 no-underline">
                                    <IoEarth size={14} className="text-indigo-500"/>
                                    <span className="font-medium text-xs tracking-wider leading-snug">
                                            {website.replace(/^https?:\/\//, '')}
                                        </span>
                                </a>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
})

export default OrganizationBanner
